// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".qr-code-image[data-v-2b2890c0]{display:block;margin-top:3px;max-width:120px;width:100%;height:auto}", ""]);
// Exports
module.exports = exports;
